module.exports = __webpack_public_path__ + "img/student_25.925ef96a.png";